<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group label="原密碼:" label-for="input-1">
        <b-form-input id="input-1" v-model="form.oldpassword" type="password" required></b-form-input>
      </b-form-group>
      <b-form-group label="新密碼:" label-for="input-1">
        <b-form-input id="input-1" v-model="form.newpassword" type="password" required placeholder></b-form-input>
      </b-form-group>
      <b-form-group label="確認密碼:" label-for="input-1">
        <b-form-input id="input-1" v-model="form.confirmpassword" 　type="password" required></b-form-input>
      </b-form-group>
      <transition name="hint" appear>
        <div v-if="passwordValidation.errors.length > 0 " class="hints">
          <p v-for="error in passwordValidation.errors">{{error}}</p>
        </div>
      </transition>
      <div class="matches" v-if="notSamePasswords">
        <p>新密碼不一致</p>
      </div>
      <b-form-group style="text-align:center;">
        <b-button
          type="submit"
          v-if="passwordsFilled && !notSamePasswords && passwordValidation.valid"
          variant="primary"
          style="width: auto"
        >變更密碼</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { AuthenticationHandler } from "@/handler/AuthenticationHandler.js";
import { Loading } from "element-ui";
export default {
  props: ["tutorChatToken"],
  data() {
    return {
      form: {
        oldpassword: "",
        newpassword: "",
        confirmpassword: ""
      },
      rules: [
        { message: "至少一個小寫字母", regex: /[a-z]+/ },
        { message: "至少一個大寫字母.", regex: /[A-Z]+/ },
        { message: "密碼長度最少8", regex: /.{8,}/ },
        { message: "至少一個數字", regex: /[0-9]+/ }
      ]
    };
  },
  created() {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let loadingInstance = Loading.service({ fullscreen: true });
      var result = AuthenticationHandler.ChangeSalesAgentPasswords(
        this.form,
        this.tutorChatToken
      );
      loadingInstance.close();

      if (result.Success) {
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.form.oldpassword = "";
        this.form.newpassword = "";
        this.form.confirmpassword = "";
      } else {
        this.$message.error(result.DisplayMessage);
      }
    }
  },
  computed: {
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.form.newpassword !== this.form.confirmpassword;
      } else {
        return false;
      }
    },
    passwordsFilled() {
      return this.form.newpassword !== "" && this.form.confirmpassword !== "";
    },
    passwordValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.form.newpassword)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ChangePassword.vue